import { Platform, Dimensions } from 'react-native';
import { CO_OYO_BFF, HMS_BFF } from './apiHosts';
import getDeviceType from '../utils/getDeviceType';
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || '';
const TRUECALLER_CLIENT_ID = process.env.REACT_APP_TRUECALLER_CLIENT_ID || '';

export const CO_API_HOST = CO_OYO_BFF;
export const HMS_BFF_API_HOST = HMS_BFF;

export const genericNudgePageTypes = {
  bookingListGenericNudge: 'booking_list_screen'
};

export const genericNudgePageRouteMapping = {
  [genericNudgePageTypes.bookingListGenericNudge]: 'listingScreen'
};

export const genericNudgesCampaignTypes = {
  booking_nudges: 'booking_nudges'
};

export const SUBSCRIPTION_HOTEL = 'subscription hotel';

export const NOTIFICATION_STATUS = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  GENERIC: 'GENERIC',
  FAILURE: 'FAILURE'
};

export const FONT_FAMILY = {
  REGULAR: 'Brown-Regular',
  BOLD: 'Brown-Bold'
};

const isMobileDevice = () => {
  if (Platform.OS == 'android' || Platform.OS == 'ios') {
    return true;
  }
  return false;
};

export const IMAGE_COMPRESSION_CONSTANTS = {
  IMAGE_COMPRESSION_OUTPUT: 'JPEG',
  COMPRESSED_IMAGE_TYPE: 'image/jpeg'
};

export const IS_MOBILE_DEVICE = isMobileDevice();

export const LOGIN_DEVICE_ROLE = {
  OWNER_PORTAL_USER: 'Owner_Portal_User',
  EMPLOYEE: 'Employee',
  PROPERTY_MANAGER: 'PropertyManager'
} as const;

export const RollsCode = {
  'Hotel Manager': 0,
  'propertymanager': 0,
  'owner': 1,
  'frontofficemanager': 2,
  'housekeepingapp': 3,
  'Housekeeping Staff': 3,
  'administrator': 4,
  'propertymanager-oyohomes': 5,
  'accountant': 6,
  'frontofficeclerk': 7
};

export const TERMS_OF_SERVICE_URL = {
  TERMS_OF_SERVICE_URL: 'https://partners.oyorooms.com/terms-of-service'
};

export const DIRECTION_LTR = 'ltr';
export const DIRECTION_RTL = 'rtl';

export const imageSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

export const EVENT_ACTIONS = {
  VIEWED: 'Viwed',
  UNMOUNT: 'Unmount',
  CLICK: 'Click',
  CONFIRM_CLICK: 'Confirm Clicked',
  DONE_CLICKED: 'Done Clicked',
  READ_MORE_CLICKED: 'Read Mored Clicked',
  BACK_CLICKED: 'Back Clicked'
};

const { isPhone, isMobileBrowser, isIos, isAndroid, isDesktopBrowser, isTabletBrowser, isTablet } = getDeviceType();
export const SHOULD_RENDER_MOBILE_DESIGN = isPhone || isMobileBrowser;
export const CROSS_SELL_NUDGE = 'CROSS_SELL_NUDGE';
export const BOOKING_LIST_TAB_WIDTH = 'BOOKING_LIST_TAB_WIDTH';
export const IS_MOBILE_BROWSER = isMobileBrowser;
export const IS_PHONE = isPhone;
export const IS_NATIVE_DEVICE = isIos || isAndroid;
export const IS_ANDROID_NATIVE_DEVICE = isAndroid;
export const IS_IOS_NATIVE_DEVICE = isIos;
export const IS_LARGE_WIDTH_DEVICE = isDesktopBrowser || isTabletBrowser || isTablet;
export const IS_SMALL_WIDTH_DEVICE = isPhone || isMobileBrowser;
export const IS_TABLET_MOBILE = isMobileBrowser || isTabletBrowser || isTablet || isPhone;

export const WINDOW_WIDTH = Dimensions.get('window').width;
export const WINDOW_HEIGHT = Dimensions.get('screen').height;
export const OVH_NAME = 'OVH';
export const OYO360_OTPSIGNUP_VIEW = '/propertyOnboard/sign_up';
export const OYOOS_LOGIN_PAGE = '/';
export const BLUEIMP_LOADIMAGE_LIB_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/blueimp-load-image/5.16.0/load-image.all.min.js';

export const APPLE_SIGN_IN = {
  SCRIPT_LINK: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
  MODE: 'APPLE',
  QUERY_PARAMS: {
    clientId: 'com.oyoos.signin',
    redirectURI: REDIRECT_URI + '/propertyOnboard/social_login/apple',
    // not used, only present since it is a mandatory field
    scope: 'name email',
    usePopup: true
  },
  LABEL: 'apple'
};

export const TRUECALLER_SIGN_IN = {
  AUTH_LINK: 'truecallersdk://truesdk/web_verify',
  MODE: 'TRUECALLER',
  DEEP_LINK_WINDOW_EXPIRY: 1000,
  POLLING_COUNT: 3,
  POLLING_INTERVAL: 1000,
  POLLING_CONTINUE_ERROR_MSG: 'No callback received',
  USED_ANOTHER_NUMBER: 'used_another_number',
  SDK_CLOSE_TIME_CHECK: 500,
  QUERY_PARAMS: {
    type: 'btmsheet',
    partnerKey: TRUECALLER_CLIENT_ID,
    partnerName: 'OYO',
    lang: 'en',
    skipOption: 'useanothermethod',
    ctaPrefix: 'continuewith'
  },
  LABEL: 'truecaller'
};

export const BOOKING_SOURCE = {
  WALK_IN: 'Walkin',
  OTA: 'Online Travel Agent'
};

export const BLACK_SELLABLE_ROOM_ID = '__black_sellable_room_id__';

export const INTENTS_LIST = {
  CREATE_BOOKING: { id: 'createBooking' },
  SELL_WIZARD: { id: 'sellWizard' }
};

export const OYOOS_HOST = 'https://www.oyoos.com';
export const PRICE_CHANGE_AUTH_MODULE = 'ChangePriceForSmartPricing';
export const PRICE_CHANGE_AUTH_MODULE_RM = 'ChangePriceForSmartPricingForRm';
export const GX_NUMBERS_AUTH_MODULE = 'UpdateGXNumbers';
export const OYO_BOOKING_TYPES = {
  WALK_IN: 'Walk In'
};

export const PAGE_VIEW_KEY = 'page_view';

export const NAVIGATION_GA_CATEGORY = 'navigation';

export const CHANGE_PAGE_ACTION = 'change_page';

export const X_OYO_PLATFORM = {
  web: 'hms_web',
  android: 'cooyo_android',
  ios: 'cooyo_ios'
};

export const LOGIN_PERSONNEL = {
  PM: 'PM',
  OWNER: 'OWNER',
  EMPLOYEE: 'Employee'
};

export const GUEST_CARD = {
  BULK_PRINT_GUEST_CARD: 'BULK_PRINT_GUEST_CARD',
  PRINT_GUEST_CARD: 'PRINT_GUEST_CARD',
  GET_GUEST_CARD_AVAILABLE_LANG: 'GET_GUEST_CARD_AVAILABLE_LANG',
  GET_SUPPORTED_FEATURES: 'GET_SUPPORTED_FEATURES'
};

export const COMMON_TRANSLATIONS_FEATURE = 'HOME';

export const OCR_STATUS = {
  PROCESSING: 'PRO',
  ERROR: 'ERR',
  COMPLETED: 'COM'
};

export const BOTTOM_TAB_BAR_HEIGHT = 64;

export const APP_BAR_HEIGHT = 56;

export const APP_BAR_HEIGHT_WITH_BOTTOM_TEXT = 66;

export const DESKTOP_HEADER_HEIGHT = 72;

export const SUPER_OYO_PROPERTY_TAG = 'super_oyo';

export const ANDROID_API_VERSIONS = {
  ANDROID_10: 29,
  ANDROID_13: 33
};

export const DECIMAL_AMOUNT_REGEX = /^\d+(\.\d{0,2})?$/;
export const INTEGER_REGEX = /^\d*$/;
export const ALPHABET_REGEX = /^[a-zA-Z]*$/;

export const LEAD_COPIED_TO_CLIPBOARD_MESSAGE = 'Lead ID copied';

export const EXHAUSTED_ATTEMPS_ERROR_MESSAGE = 'You have exhausted your attempts to generate OTP';

export const WIDGET_TYPES = {
  RECONFIRMATION_HEADER: 'reconfirmationHeader',
  RECONFIRMATION_BENEFITS: 'reconfirmationBenefits',
  RECONFIRMATION_FOOTER: 'reconfirmationFooter'
};

export const eventNames = {
  CURRENT_POSITION: 'CURRENT_POSITION'
};

export const eventCategories = {
  LOCATION_DENIED: 'LOCATION_DENIED',
  LOCATION_GIVEN: 'LOCATION_GIVEN'
};

export const eventActions = {
  LOCATION_DENIED: 'LOCATION_DENIED',
  LOCATION_GIVEN: 'LOCATION_GIVEN'
};

export const NOTIFICATION_MODE = {
  SMS: 'SMS'
};

export const LOCAL_STORAGE_AND_COOKIE_ITEM_KEYS = {
  LANGUAGE: 'language',
  ACCESS_TOKEN: 'accessToken',
  IS_LOGGED_IN: 'isLoggedIn',
  ENTITY_ID: 'entityId',
  USER_DETAILS: 'user_details',
  CLIENT: 'client'
} as const;

export const SOURCE_CLIENT_HOST_NAMES_MATCHERS = {
  DAN_CENTER: 'dancenter',
  MESSAGE_CENTER: 'messagecenter'
} as const;

export const SOURCE_CLIENTS = {
  MERCHANT: 'merchant',
  DAN_CENTER: 'dan_center',
  MESSAGE_CENTER: 'message_center'
} as const;

export const HTTP_REQUEST_HEADERS = {
  X_SOURCE_CLIENT: 'X-Source-Client'
} as const;

export const KEYBOARD_KEYS = {
  ENTER: 'Enter'
};

export const COOKIE_KEYS = {
  AKAMAI_HEADER: 'x-akamai-edgescape',
  AKAMAI_COUNTRY_CODE: 'country_code='
};

export const INTENTS_STRING = {
  CHANGE_OCCUPANCY: 'ChangeOccupancy',
  CHANGE_CATEGORY: 'ChangeCategory',
  MODIFY_DATES: 'ModifyDates',
}
